export function normalizeVerificationMethod(method) {
  return String(method || '').trim().toLowerCase()
}

function signSessionVerificationMethodKey(signerAccessCode) {
  return `assinafy:sign:${signerAccessCode}:verification_method`
}

export function writeSignSessionVerificationMethod(signerAccessCode, method) {
  if (!signerAccessCode || method == null || String(method).trim() === '') return
  try {
    sessionStorage.setItem(signSessionVerificationMethodKey(signerAccessCode), String(method))
  } catch {
    /* ignore */
  }
}

export function readSignSessionVerificationMethod(signerAccessCode) {
  if (!signerAccessCode) return undefined
  try {
    const v = sessionStorage.getItem(signSessionVerificationMethodKey(signerAccessCode))
    return v && v.trim() ? v : undefined
  } catch {
    return undefined
  }
}

/**
 * state da rota → ?vm= → session (gravado na sucesso) → perfil do signatário.
 */
export function resolveSignFlowVerificationMethod({
  routerStateMethod,
  queryVm,
  signerAccessCode,
  signerMethod,
}) {
  if (routerStateMethod != null && String(routerStateMethod).trim() !== '') {
    return routerStateMethod
  }
  if (queryVm != null && String(queryVm).trim() !== '') {
    try {
      return decodeURIComponent(queryVm)
    } catch {
      return queryVm
    }
  }
  const stored = readSignSessionVerificationMethod(signerAccessCode)
  if (stored) return stored
  return signerMethod
}

/**
 * Pendentes virtuais do signatário; com methodFromFlow definido, restringe ao mesmo canal (email/whatsapp).
 */
export function filterPendingVirtualDocumentsForSigner(documents, signer, methodFromFlow) {
  const methodFromSignedFlow = normalizeVerificationMethod(methodFromFlow)
  const signerId = signer?.id
  if (!Array.isArray(documents)) return []
  return documents.filter((document) => {
    if (document?.assignment?.method !== 'virtual') return false

    const summarySigner = document?.assignment?.summary?.signers?.find(
      (s) => String(s?.id) === String(signerId),
    )
    if (!summarySigner || summarySigner.completed) return false

    if (!methodFromSignedFlow) return true

    const assignmentSigner = document?.assignment?.signers?.find(
      (s) => String(s?.id) === String(signerId),
    )
    const methodOnDoc = normalizeVerificationMethod(
      assignmentSigner?.verification_method || summarySigner?.verification_method,
    )

    return methodOnDoc === methodFromSignedFlow
  })
}

/**
 * Método de verificação do signatário atual no documento (para passar no state do navigate).
 * Prioriza assignment.signers (mesmo usuário que acabou de assinar), depois signer e router state.
 */
export function getSignedVerificationMethodForNavigate(document, signer, routerState) {
  const list = document?.assignment?.signers
  if (Array.isArray(list) && signer) {
    const match = list.find(
      (s) =>
        (signer.id != null && String(s?.id) === String(signer.id)) ||
        (s?.email &&
          signer.email &&
          String(s.email).trim().toLowerCase() === String(signer.email).trim().toLowerCase()),
    )
    if (match?.verification_method) return match.verification_method
  }
  return (
    signer?.verification_method ||
    routerState?.verification_method ||
    'Email'
  )
}
